class NMPTestMode extends HTMLElement {
  constructor() {
    super();
    this.config = {
      dom: {
        modal: '.ac-modal-trigger[data-ajax-url], .ac-modal-trigger[data-modal-target]',
        buttons: '.js-nmp-button',
        options: '.js-nmp-option',
        selects: '.js-nmp-select',
        active_price: '.js-nmp-active-price',
        total: '.js-nmp-total-price',
        frequency: '.js-nmp-total-frequency',
        terms: '.js-nmp-terms',
      },
      cls: {
        active: 'active'
      }
    }
    
    this.b2bWrapper
    this.modals = document.querySelectorAll(this.config.dom.modal) || [];

      if (this?.modals?.length > 0) {
        this.addModalEvents();

        window.refreshNmpAddModalEvents = () => {
          this.modals = document.querySelectorAll(this.config.dom.modal) || [];
          this.addModalEvents();
        }
      }
  }

  async getNMPTerms(handle, isCart) {
    const url = isCart ? '/?section_id=nmp-test-mode-plan-cart' : `/products/${handle}?view=nmp`;
    const $terms = this.querySelector(this.config.dom.terms) || null;
    const res = await fetch(url);
    const $html = await res.text() || null;

    let activeOption = false
    if ($terms && $html) {
      $terms.innerHTML = $html;
      let nmpObject = localStorage.getItem('financing')
      if (nmpObject && nmpObject != '') {
        nmpObject = nmpObject.replace(' ', '').replace(this.dataset.shortFrequency, '')
        let selectOption = document.querySelector(`.select-custom.js-nmp-select option[data-term="${nmpObject}"]`)
        if (selectOption) {
          activeOption = true
          document.querySelector(`.select-custom.js-nmp-select`).value = selectOption.value
        }
      }
    }
    this.checkB2BCalculator();
    this.addSelectEvents();
    if (activeOption) {
      document.querySelector(`.select-custom.js-nmp-select`).dispatchEvent(new Event('change'))
    }
    this.addButtonsEvents();
  };

  addModalEvents() {
    this?.modals?.forEach((modal) => {
      modal.addEventListener('click', () => {
         const { product, price } = modal.dataset || {};

         if (product) {
          this.getNMPTerms(product);
         }

         if (price) {
          this.getNMPTerms(null, true);
         }
      });
    });
  }

  addSelectEvents() {
    const $selects = this.querySelectorAll(this.config.dom.selects) || [];

    if ($selects?.length > 0) {
      [...$selects].forEach(($select) => {
        $select.addEventListener('change', () => {
          const { value } = $select || {};

          if (value) {
            const $activeOption = $select.querySelector(`option[value="${value}"]`) || null;

            if ($activeOption) {
              const term = $activeOption.dataset.term || '';
              this.updatePrice(value, term);
              let currentFinancialTerm = term + ' ' + this.dataset.shortFrequency
              localStorage.setItem('financing', currentFinancialTerm)
              document.dispatchEvent(new CustomEvent('nmp:updatePrice'))
            }
          }
        });
      });
    }
  }
  addButtonsEvents() {
    const $buttons = this.querySelectorAll(this.config.dom.buttons) || [];

    if ($buttons?.length > 0) {
      [...$buttons].forEach(($button) => {
        $button.addEventListener('click', () => {
          this.setActiveTerms($button);
        });
      });
    }
  }

  resetState() {
    const $buttons = this.querySelectorAll(this.config.dom.buttons) || [];
    const $options = this.querySelectorAll(this.config.dom.options) || [];
    const $selects = this.querySelectorAll(this.config.dom.selects) || [];

    if ($buttons?.length > 0) {
      [...$buttons].forEach(($button) => {
        $button.classList.remove(this.config.cls.active);
      });
    }

    if ($options?.length > 0) {
      [...$options].forEach(($option) => {
        $option.classList.remove(this.config.cls.active);
      });
    }

    if ($selects?.length > 0) {
      [...$selects].forEach(($select) => {
        $select.selectedIndex = 0;
      });
    }
  }

  setActiveTerms(el) {
    
    if (!el) return;

    const $button = el;
    const { id } = $button || {};

    if (id) {
      this.resetState();

      $button.classList.add(this.config.cls.active);
      const $terms = document.getElementById(`${id}-option`) || null;

      if ($terms) {
        const $select = $terms.querySelector(this.config.dom.selects) || null;

        if ($select) {
          const $firstOption = $select.querySelector('option') || null;

          if ($firstOption?.value) {
            const term = $firstOption.dataset.term || '';

            this.updatePrice($firstOption.value, term);
          }
        }

        $terms.classList.add(this.config.cls.active);
      }
    }
  }

  updatePrice(val, term ='') {
    const $activePrice = this.querySelectorAll(this.config.dom.active_price) || [];
    const $totals = this.querySelectorAll(this.config.dom.frequency) || [];
    const frequencyText = this.dataset.frequency || null;

    if ($activePrice?.length > 0) {
      [...$activePrice].forEach(($price) => {
        $price.innerHTML = val;
      });
    }

    if (frequencyText && $totals?.length > 0) {
      const frequency = frequencyText.replace('{{ per_month }}', term);

     if ($totals?.length > 0) {
        [...$totals].forEach(($total) => {
          $total.innerHTML = frequency;
        });
      }
    }
  }

  checkB2BCalculator() {
    this.b2bWrapper = document.querySelector('section.nmp-test-mode__plan-copy.js-nmp-option[data-b2b]')
    if (!this.b2bWrapper) return
    if (this.b2bWrapper.dataset.product == '') {
      this.b2bWrapper.querySelectorAll('.b2b-hidden').forEach(el => {
        el.classList.add('hidden')
      })
      return
    }
    this.b2bWrapper.querySelector('select').classList.add('hidden')
    fetch(`https://topi-proxy.lukas-551.workers.dev/v1/catalog/products?term=${this.b2bWrapper.dataset.product}`)
      .then(response => {return response.json()})
      .then(data => {
        if (data.length == 0) {
          this.b2bWrapper.classList.add('nmp-test-mode__plan-copy--error')
          this.b2bWrapper.querySelector('.b2b-error')
          return
        }
        let product = data[0]
        let defaultDuration = product.available_contract_terms.rent.duration
        if (product.available_contract_terms.can_rent) {
          this.getMonthlyPricing(product.list_price, product.base_rental_price, this.b2bWrapper.dataset.product, defaultDuration)
        } else {
        }
      })
  }

  getMonthlyPricing(price, base_rental_price, productTerm, defaultDuration) {
    fetch('https://topi-proxy.lukas-551.workers.dev/v1/catalog/carts/rental-overview', {
    method: 'POST',
    body: JSON.stringify({
      "products": [
        {
          base_rental_price,
          price,
          "quantity": 1,
          "seller_product_reference": {
            "reference": `${productTerm}`,
            "source": "ID"
          }
        }
      ]
    }
  )
  })
    .then(response => {return response.json()})
    .then(data => {
      if (data.can_checkout == false) {
        this.b2bWrapper.classList.add('nmp-test-mode__plan-copy--error')
        this.b2bWrapper.querySelector('.b2b-error')
        return
      } else {
        this.buildOptions(data, defaultDuration)
      }
    })
  }

  buildOptions(data, defaultDuration) {
    const moneyFormater = new Intl.NumberFormat(Shopify.locale);
    let priceList = data.product_prices[0].available_rental_terms.reverse()
    let select = this.b2bWrapper.querySelector('select.select-custom.js-nmp-select')
    
    let frequency = this.b2bWrapper.dataset.frequency
    select.innerHTML = ''
    for (let i = 0; i < priceList.length; i++) {
      select.innerHTML += `<option value="${moneyFormater.format(priceList[i].monthly_amount.gross / 100) + '€'}" data-monthly="${moneyFormater.format(priceList[i].monthly_amount.gross / 100) + '€'}" data-term="${priceList[i].duration}">${priceList[i].duration} ${frequency}</option>`
    }
    this.b2bWrapper.querySelector('select').classList.remove('hidden')
    let activeValue = moneyFormater.format(priceList[0].monthly_amount.gross / 100) + '€'
    this.updatePrice(activeValue, `${priceList[0].duration} ${frequency}`)
  }
}

customElements.define("nmp-test-mode", NMPTestMode);
